import { useLayoutEffect, useState } from 'react';

/**
 * Altura de uma barra fixa (`position: sticky`), para a página descontar o
 * espaço que ela ocupa no topo. Quando a barra não está fixa (celular),
 * devolve 0. Devolve `{ ref, height }`; `ref` é uma ref de callback.
 */
export default function useStickyHeight() {
  const [element, setElement] = useState(null);
  const [height, setHeight] = useState(0);

  useLayoutEffect(() => {
    if (!element) return undefined;
    const measure = () => {
      const sticky = window.getComputedStyle(element).position === 'sticky';
      setHeight(sticky ? Math.ceil(element.getBoundingClientRect().height) : 0);
    };
    measure();
    if (typeof ResizeObserver === 'undefined') return undefined;
    const observer = new ResizeObserver(measure);
    observer.observe(element);
    return () => observer.disconnect();
  }, [element]);

  return { ref: setElement, height };
}
